module.exports = __webpack_public_path__ + "img/hamburger.55704186.svg";